// extracted by mini-css-extract-plugin
export var wrapper = "contacts-module--wrapper--KRQTP";
export var description = "contacts-module--description--kOS2i";
export var list = "contacts-module--list--XjEZj";
export var item = "contacts-module--item--fmf6Z";
export var item__title = "contacts-module--item__title--Z5+0-";
export var item__content = "contacts-module--item__content---evIY";
export var activeItem = "contacts-module--activeItem--ZVal7 contacts-module--item--fmf6Z";